"use strict";

var LoggerInstance = require("js-logger").get("BootstrapPrompt");

var ReactHelper = require("./ReactHelper");
var Wizard = require("./Wizard");

var BootstrapPrompt = {
	alert: function (options, callback) {
		var defaultOptions = {
			type: BootstrapDialog.TYPE_DANGER,
			title: window.MODAL_TITLES.ERROR,
			onshown: (dialogRef) => {
				dialogRef.$modalFooter.find("button").first().focus();
			},
			closable: true,
			callback: callback
		};
		if (typeof options !== "object") {
			options = { message: options };
		}
		options = Object.assign({}, this._getPublishedPageButtonLabels(), defaultOptions, options);
		BootstrapDialog.alert(options);
	},

	success: function (message, callback) {
		BootstrapDialog.alert({
			type: BootstrapDialog.TYPE_SUCCESS,
			title: window.MODAL_TITLES.SUCCESS,
			onshown: (dialogRef) => {
				dialogRef.$modalFooter.find("button").first().focus();
			},
			closable: true,
			message,
			callback
		});
	},

	confirm: function (options, callback) {
		var defaultOptions = {
			type: BootstrapDialog.TYPE_PRIMARY,
			title: window.MODAL_TITLES.INFORMATION,
			onshown: (dialogRef) => {
				dialogRef.$modalFooter.find("button").first().focus();
			},
			closable: false,
			callback: callback,
			btnOKClass: "btn btn-success"
		};

		if (typeof options !== "object") {
			options = { message: options };
		}
		options = Object.assign({}, this._getPublishedPageButtonLabels(), defaultOptions, options);
		BootstrapDialog.confirm(options);
	},

	show: function (options, callback) {
		var defaultOptions = {
			type: BootstrapDialog.TYPE_PRIMARY,
			title: window.MODAL_TITLES.INFORMATION,
			onshown: (dialogRef) => {
				dialogRef.$modalFooter.find("button").first().focus();
			},
			callback: callback
		};

		// We're not passing the published page button labels into this call because a) .show is only used
		// in designer pages, not published pages and b) .show requires a button array to be passed in as
		// options and will ignore all the values that we pass in.
		options = Object.assign({}, defaultOptions, options);
		BootstrapDialog.show(options);
	},

	prompt: function (options, callback) {
		options = options || {};
		var message = options.message || "";
		var placeholder = options.placeholder || "";
		var publishedPageButtonLabels = this._getPublishedPageButtonLabels();

		BootstrapDialog.show({
			message: `${message} <input type="text" class="dialog-input form-control" value="${placeholder}">`,
			type: BootstrapDialog.TYPE_PRIMARY,
			title: window.MODAL_TITLES.INFORMATION,
			onshown: function (dialogRef) {
				var el = $(".bootstrap-dialog-body input:text.dialog-input.form-control").get(0);
				var elemLen = el.value.length;

				el.selectionStart = elemLen;
				el.selectionEnd = elemLen;
				el.focus();
			},
			buttons: [{
				id: "submit",
				label: publishedPageButtonLabels.btnOKLabel || "OK",
				action: (dialogRef) => {
					var value = $.trim(dialogRef.getModalBody().find("input").val());

					callback(value);

					dialogRef.close();
				}
			}, {
				id: "cancelButton",
				label: publishedPageButtonLabels.btnCancelLabel || "Cancel",
				action: (dialogRef) => {
					dialogRef.close();
				}
			}]
		});
	},

	wizard: function (wizardOptions, callback) {
		var questions = wizardOptions.questions;
		var submitText = wizardOptions.submitText;
		var cancelText = wizardOptions.cancelText;
		var canSubmit = wizardOptions.canSubmit === false ? false : true; //true is the default value, so undefined must equate to true
		var canCancel = wizardOptions.canCancel === false ? false : true; //true is the default value, so undefined must equate to true
		var savedModel = wizardOptions.savedModel;
		var initializeModelFromSavedModel = wizardOptions.initializeModelFromSavedModel;
		var allowPartialSave = wizardOptions.allowPartialSave;
		var WizardComponent = wizardOptions.wizardComponent || Wizard;
		var title = wizardOptions.title || window.MODAL_TITLES.INFORMATION;
		var dialogOptions = wizardOptions.dialogOptions;
		var additionalPages = wizardOptions.additionalPages;
		var cancelCallback = wizardOptions.cancelCallback;
		var onInitialDataLoadFunction = wizardOptions.onInitialLoadData;
		var isDelayOpen = wizardOptions.isDelayOpen; //This means we need some data from the API before we show the first form.

		var handleSaveWizard = (dialogRef, model, isPartialSave) => {
			dialogRef.$modal.hide();
			if ((typeof callback === "function")) {
				callback(model, isPartialSave);
			}
			dialogRef.close();
		};

		var handleCloseWizard = (dialogRef) => {
			if ((typeof cancelCallback === "function")) {
				cancelCallback();
			}
			dialogRef.$modal.hide();
			dialogRef.close();
		};

		var handleWizardClosed = (dialogRef) => {
			ReactHelper.unmountElement(dialogRef.$modalBody.find("#wizardMountPoint")[0]);
		};

		var defaultOptions = {
			message: (dialog) => {
				return $(`<div id="wizardMountPoint"></div>`);
			},
			type: BootstrapDialog.TYPE_PRIMARY,
			title: title,
			onshown: (dialogRef) => {
				var props = {
					paragraph: wizardOptions.paragraph,
					questions,
					additionalPages,
					allowPartialSave,
					savedModel,
					initializeModelFromSavedModel,
					isDelayOpen,
					canSubmit,
					canCancel,
					cancelText,
					submitText,
					dialog: dialogRef,
					onInitialLoadData: onInitialDataLoadFunction,
					onSave: (model, isPartialSave) => { handleSaveWizard(dialogRef, model, isPartialSave); },
					onCancel: () => { handleCloseWizard(dialogRef); }
				};

				props = Object.assign({}, props, wizardOptions.props);

				var root = ReactHelper.getRoot($("#wizardMountPoint")[0]);
				root.render(React.createElement(WizardComponent, props));
				// If any code is added after this, that looks at the React component, it would need to be put in a defer as the render happens asynchronously.
			},
			onhide: (dialogRef) => { handleWizardClosed(dialogRef); }
		};
		dialogOptions = Object.assign({}, defaultOptions, dialogOptions);

		BootstrapDialog.show(dialogOptions);
	},

	_getPublishedPageButtonLabels() {
		if (!window.BUTTON_LABELS) {
			return {};
		}

		return {
			btnOKLabel: window.BUTTON_LABELS.OK,
			btnCancelLabel: window.BUTTON_LABELS.CANCEL,
			buttonLabel: window.BUTTON_LABELS.OK,
		}
	}
};

module.exports = BootstrapPrompt;
